import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'Customer',
    column_type: 'id',
  },
  created_at: {
    model_name: 'Customer',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'Customer',
    column_type: 'datetime',
  },
  name: {
    model_name: 'Customer',
    column_type: 'string',
  },
  user: {
    model_name: 'Customer',
    column_type: 'belongs_to',
    extra: {
      association_name: 'user',
      model_name: 'User',
    },
  },
  user_id: {
    model_name: 'Customer',
    column_type: 'belongs_to',
    extra: {
      association_name: 'user',
      model_name: 'User',
    },
  },
  customer_level: {
    model_name: 'Customer',
    column_type: 'belongs_to',
    extra: {
      association_name: 'customer_level',
      model_name: 'CustomerLevel',
    },
  },
  customer_level_id: {
    model_name: 'Customer',
    column_type: 'belongs_to',
    extra: {
      association_name: 'customer_level',
      model_name: 'CustomerLevel',
    },
  },
  customer_source: {
    model_name: 'Customer',
    column_type: 'belongs_to',
    extra: {
      association_name: 'customer_source',
      model_name: 'CustomerSource',
    },
  },
  customer_source_id: {
    model_name: 'Customer',
    column_type: 'belongs_to',
    extra: {
      association_name: 'customer_source',
      model_name: 'CustomerSource',
    },
  },
  customer_kind: {
    model_name: 'Customer',
    column_type: 'belongs_to',
    extra: {
      association_name: 'customer_kind',
      model_name: 'CustomerKind',
    },
  },
  customer_kind_id: {
    model_name: 'Customer',
    column_type: 'belongs_to',
    extra: {
      association_name: 'customer_kind',
      model_name: 'CustomerKind',
    },
  },
  customer_connection: {
    model_name: 'Customer',
    column_type: 'belongs_to',
    extra: {
      association_name: 'customer_connection',
      model_name: 'CustomerConnection',
    },
  },
  customer_connection_id: {
    model_name: 'Customer',
    column_type: 'belongs_to',
    extra: {
      association_name: 'customer_connection',
      model_name: 'CustomerConnection',
    },
  },
  customer_transaction: {
    model_name: 'Customer',
    column_type: 'belongs_to',
    extra: {
      association_name: 'customer_transaction',
      model_name: 'CustomerTransaction',
    },
  },
  customer_transaction_id: {
    model_name: 'Customer',
    column_type: 'belongs_to',
    extra: {
      association_name: 'customer_transaction',
      model_name: 'CustomerTransaction',
    },
  },
  create_date: {
    model_name: 'Customer',
    column_type: 'date',
  },
  manager: {
    model_name: 'Customer',
    column_type: 'string',
  },
  phone: {
    model_name: 'Customer',
    column_type: 'string',
  },
  customer_level_fixed: {
    model_name: 'Customer',
    column_type: 'boolean',
  },
  trade_heat: {
    model_name: 'Customer',
    column_type: 'string',
  },
  last_7_day_order_qty: {
    model_name: 'Customer',
    column_type: 'string',
  },
  last_7_day_order_amount: {
    model_name: 'Customer',
    column_type: 'string',
  },
  last_30_day_order_qty: {
    model_name: 'Customer',
    column_type: 'string',
  },
  last_30_day_order_amount: {
    model_name: 'Customer',
    column_type: 'string',
  },
  last_month_order_qty: {
    model_name: 'Customer',
    column_type: 'string',
  },
  last_month_order_amount: {
    model_name: 'Customer',
    column_type: 'string',
  },
  customer_tags: {
    model_name: 'Customer',
    column_type: 'has_many',
    extra: {
      association_name: 'customer_tags',
      model_name: 'CustomerTag',
      foreign_key: 'customer_id',
    },
  },
  customer_tag_ids: {
    model_name: 'Customer',
    column_type: 'has_many',
    extra: {
      association_name: 'customer_tags',
      model_name: 'CustomerTag',
      foreign_key: 'customer_id',
    },
  },
  customer_business_models: {
    model_name: 'Customer',
    column_type: 'has_many',
    extra: {
      association_name: 'customer_business_models',
      model_name: 'CustomerBusinessModel',
      foreign_key: 'customer_id',
    },
  },
  customer_business_model_ids: {
    model_name: 'Customer',
    column_type: 'has_many',
    extra: {
      association_name: 'customer_business_models',
      model_name: 'CustomerBusinessModel',
      foreign_key: 'customer_id',
    },
  },
  product_styles: {
    model_name: 'Customer',
    column_type: 'has_many',
    extra: {
      association_name: 'product_styles',
      model_name: 'ProductStyle',
      foreign_key: 'customer_id',
    },
  },
  product_style_ids: {
    model_name: 'Customer',
    column_type: 'has_many',
    extra: {
      association_name: 'product_styles',
      model_name: 'ProductStyle',
      foreign_key: 'customer_id',
    },
  },
  sale_channels: {
    model_name: 'Customer',
    column_type: 'has_many',
    extra: {
      association_name: 'sale_channels',
      model_name: 'SaleChannel',
      foreign_key: 'customer_id',
    },
  },
  sale_channel_ids: {
    model_name: 'Customer',
    column_type: 'has_many',
    extra: {
      association_name: 'sale_channels',
      model_name: 'SaleChannel',
      foreign_key: 'customer_id',
    },
  },
  need_supplement_information: {
    model_name: 'Customer',
    column_type: 'string',
  },
  last_follow_record_of_user_followed_at: {
    model_name: 'Customer',
    column_type: 'string',
  },
  assign_to_user: {
    model_name: 'Customer',
    column_type: 'belongs_to',
    extra: {
      association_name: 'assign_to_user',
      model_name: 'User',
    },
  },
  assign_to_user_id: {
    model_name: 'Customer',
    column_type: 'belongs_to',
    extra: {
      association_name: 'assign_to_user',
      model_name: 'User',
    },
  },
  rest_amount: {
    model_name: 'Customer',
    column_type: 'string',
  },
  annual_status_list: {
    model_name: 'Customer',
    column_type: 'tag',
  },
  annual_status_manual: {
    model_name: 'Customer',
    column_type: 'boolean',
  },
  new_customer_in_current_year: {
    model_name: 'Customer',
    column_type: 'string',
  },
  can_update: {
    model_name: 'Customer',
    column_type: 'string',
  },
  can_destroy: {
    model_name: 'Customer',
    column_type: 'string',
  },
  can_pick: {
    model_name: 'Customer',
    column_type: 'string',
  },
  can_release: {
    model_name: 'Customer',
    column_type: 'string',
  },
  can_business_executive_release: {
    model_name: 'Customer',
    column_type: 'string',
  },
  can_assign: {
    model_name: 'Customer',
    column_type: 'string',
  },
  can_apply_assign: {
    model_name: 'Customer',
    column_type: 'string',
  },
  can_cancel_apply_assign: {
    model_name: 'Customer',
    column_type: 'string',
  },
  can_approve_assign: {
    model_name: 'Customer',
    column_type: 'string',
  },
  can_reject_assign: {
    model_name: 'Customer',
    column_type: 'string',
  },
  can_follow: {
    model_name: 'Customer',
    column_type: 'string',
  },
  pool_released_reason: {
    model_name: 'Customer',
    column_type: 'string',
  },
  pool_released_user_id: {
    model_name: 'Customer',
    column_type: 'string',
  },
  pool_released_user: {
    model_name: 'Customer',
    column_type: 'string',
  },
  pool_entered_at: {
    model_name: 'Customer',
    column_type: 'string',
  },
  pool_days: {
    model_name: 'Customer',
    column_type: 'string',
  },
  latest_effective_followed_at: {
    model_name: 'Customer',
    column_type: 'string',
  },
  latest_ordered_on: {
    model_name: 'Customer',
    column_type: 'string',
  },
  can_claim: {
    model_name: 'Customer',
    column_type: 'string',
  },
  can_pool_assign: {
    model_name: 'Customer',
    column_type: 'string',
  },
  address: {
    model_name: 'Customer',
    column_type: 'string',
  },
  wechat: {
    model_name: 'Customer',
    column_type: 'string',
  },
  has_production_capacity: {
    model_name: 'Customer',
    column_type: 'boolean',
  },
  has_design_capability: {
    model_name: 'Customer',
    column_type: 'boolean',
  },
  price_preference: {
    model_name: 'Customer',
    column_type: 'string',
  },
  inquiry_content: {
    model_name: 'Customer',
    column_type: 'string',
  },
  brand: {
    model_name: 'Customer',
    column_type: 'string',
  },
  sales_ability: {
    model_name: 'Customer',
    column_type: 'string',
  },
  customer_jushuitan_order_relations: {
    model_name: 'Customer',
    column_type: 'has_many',
    extra: {
      association_name: 'customer_jushuitan_order_relations',
      model_name: 'CustomerJushuitanOrderRelation',
      foreign_key: 'customer_id',
    },
  },
  customer_jushuitan_order_relation_ids: {
    model_name: 'Customer',
    column_type: 'has_many',
    extra: {
      association_name: 'customer_jushuitan_order_relations',
      model_name: 'CustomerJushuitanOrderRelation',
      foreign_key: 'customer_id',
    },
  },
  follow_records: {
    model_name: 'Customer',
    column_type: 'has_many',
    extra: {
      association_name: 'follow_records',
      model_name: 'FollowRecord',
      foreign_key: 'customer_id',
    },
  },
  follow_record_ids: {
    model_name: 'Customer',
    column_type: 'has_many',
    extra: {
      association_name: 'follow_records',
      model_name: 'FollowRecord',
      foreign_key: 'customer_id',
    },
  },
  files: {
    model_name: 'Customer',
    column_type: 'attached',
    extra: {
      limit: 9,
      size: 5,
    },
  },
  negotiation_form: {
    model_name: 'Customer',
    column_type: 'string',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
